exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-notification[data-v-51d3dfd3] {\n        padding: 10px;\n        margin: 0 5px 5px;\n\n        font-size: 12px;\n\n        color: #ffffff;\n        background: #44A4FC;\n        border-left: 5px solid #187FE7;\n}\n.vue-notification .warn[data-v-51d3dfd3] {\n        background: #ffb648;\n        border-left-color: #f48a06;\n}\n.vue-notification .error[data-v-51d3dfd3] {\n        background: #E54D42;\n        border-left-color: #B82E24;\n}\n.vue-notification .success[data-v-51d3dfd3] {\n        background: #68CD86;\n        border-left-color: #42A85F;\n}\n", ""]);

// exports
